/**
 * Comandos com / no compositor da Mia (R23). `texto` entra no campo para a pessoa completar;
 * com `enviar`, a fala sai direto. `acoes`: basta uma (contracts/enums.yaml); vazio = todos.
 */
export type ComandoMia = {
  comando: string;
  descricao: string;
  texto: string;
  enviar?: boolean;
  acoes: number[];
};

export const COMANDOS_MIA: ComandoMia[] = [
  {
    comando: '/novidades',
    descricao: 'Agenda de hoje, notificações e pendências',
    texto: 'Quais são as novidades de hoje?',
    enviar: true,
    acoes: [],
  },
  {
    comando: '/saudacao',
    descricao: 'O mesmo resumo do dia, com bom dia',
    texto: 'Bom dia, Mia! Quais são as novidades de hoje?',
    enviar: true,
    acoes: [],
  },
  { comando: '/recado', descricao: 'Recado para a família de um aluno', texto: 'Publicar recado para ', acoes: [802] },
  { comando: '/entrada', descricao: 'Entrada de uma criança', texto: 'Registrar a entrada de ', acoes: [902] },
  { comando: '/saida', descricao: 'Saída de uma criança', texto: 'Registrar a saída de ', acoes: [902] },
  { comando: '/falta', descricao: 'Falta de uma criança', texto: 'Registrar falta de ', acoes: [902] },
  { comando: '/turma', descricao: 'Entrada da turma toda', texto: 'Registrar a entrada da turma toda do ', acoes: [902] },
  { comando: '/soninho', descricao: 'Soninho de uma criança', texto: 'Registrar que dormiu: ', acoes: [1102] },
  { comando: '/evento', descricao: 'Evento na agenda', texto: 'Marcar na agenda: ', acoes: [1701] },
  { comando: '/buscar', descricao: 'Ficha de um aluno', texto: 'Quem é ', acoes: [] },
  {
    comando: '/pendencias',
    descricao: 'O que falta fazer hoje',
    texto: 'O que está pendente hoje?',
    enviar: true,
    acoes: [801, 802, 901, 902],
  },
  {
    comando: '/resumo',
    descricao: 'Como foi o dia da escola',
    texto: 'Como foi o dia da escola hoje?',
    enviar: true,
    acoes: [801, 802, 901, 902, 1001, 1101, 1201, 1301],
  },
  { comando: '/ajuda', descricao: 'Como fazer algo no sistema', texto: 'Como faço para ', acoes: [] },
];

/** Comandos que casam com o que a pessoa digitou ("/" sozinho lista todos), so os do cargo. */
export function comandosPara(texto: string, acoes: readonly number[]): ComandoMia[] {
  if (!texto.startsWith('/') || /\s/.test(texto)) return [];
  const prefixo = texto.toLowerCase();
  return COMANDOS_MIA.filter(
    (c) => c.comando.startsWith(prefixo) && (c.acoes.length === 0 || c.acoes.some((a) => acoes.includes(a))),
  );
}
